import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import heroImage from "@/assets/hero-chillwerk.png";
import heroImageWebp1200 from "@/assets/hero-chillwerk-1200.webp";
import heroImageWebp600 from "@/assets/hero-chillwerk-600.webp";
import { Link } from "react-router-dom";

export const Hero = () => {
  return (
    <section className="relative min-h-[85vh] flex items-start md:items-center">
      {/* Gradient Background */}
      <div className="absolute inset-0 gradient-cyan" />
      
      {/* Hero Content */}
      <div className="container relative z-10 mx-auto px-4 md:px-8 pt-4 md:pt-12 lg:pt-16 pb-8 md:pb-12 lg:pb-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Text Content */}
          <div className="space-y-8 mt-4 md:mt-0">
            <h1 className="text-5xl md:text-7xl font-heading font-black leading-tight">
              <span className="block">Werk zoeken.</span>
              <span className="block whitespace-nowrap text-foreground">
                Maar dan{" "}
                <span className="text-foreground relative inline-block pb-2">
                  chill
                  <span className="absolute bottom-0 left-0 w-full h-3 md:h-4 bg-yellow shadow-lg"></span>
                </span>
                <span className="text-foreground">.</span>
              </span>
            </h1>
            
            <div className="text-xl md:text-2xl max-w-xl space-y-4">
              <p className="font-bold text-foreground">
                🎯 Zet jezelf op de radar
              </p>
              
              <p className="text-muted-foreground">
                Bedrijven solliciteren ook bij jou. Match? Start het gesprek!
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/signup/kandidaat?src=hero">
                <Button 
                  variant="cta" 
                  size="lg" 
                  className="group w-full sm:w-auto font-bold text-lg shadow-[0_6px_24px_rgba(247,255,0,0.4)] hover:shadow-[0_8px_32px_rgba(247,255,0,0.6)] hover:scale-105 transition-all duration-300 border-2 border-secondary/30"
                >
                  Zet jezelf op de radar
                  <ArrowRight className="group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
              <Link to="/werkgevers-ontmoeten">
                <Button 
                  variant="outline" 
                  size="lg" 
                  className="w-full sm:w-auto font-semibold bg-white/90 backdrop-blur-sm border-2 border-cyan/40 hover:border-cyan hover:bg-white shadow-[0_4px_16px_rgba(114,208,243,0.2)] hover:shadow-[0_6px_24px_rgba(114,208,243,0.35)] hover:scale-105 transition-all duration-300"
                >
                  Hoe het werkt
                </Button>
              </Link>
            </div>
            
            <div className="flex items-center gap-4 sm:gap-8 pt-4 pb-4">
              <div>
                <p className="text-3xl font-heading font-black text-foreground whitespace-nowrap">100%</p>
                <p className="text-sm text-muted-foreground">Gratis</p>
              </div>
              <div>
                <p className="text-3xl font-heading font-black text-foreground whitespace-nowrap">1 min</p>
                <p className="text-sm text-muted-foreground">Profiel aanmaken</p>
              </div>
              <div>
                <p className="text-3xl font-heading font-black text-foreground whitespace-nowrap">Direct</p>
                <p className="text-sm text-muted-foreground">Gevonden worden</p>
              </div>
            </div>
          </div>
          
          {/* Right: Hero Image */}
          <div className="relative hidden lg:block overflow-visible">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl z-10 aspect-square">
              <picture>
                <source
                  type="image/webp"
                  srcSet={`${heroImageWebp600} 600w, ${heroImageWebp1200} 1200w`}
                  sizes="(min-width: 1024px) 600px, 100vw"
                />
                <img
                  src={heroImage}
                  alt="Relaxed persoon in gele stoel omringd door vliegende documenten - werk zoeken maar dan chill"
                  width={1200}
                  height={1500}
                  className="w-full h-full object-cover"
                  loading="eager"
                  fetchPriority="high"
                  decoding="async"
                />
              </picture>
              <div className="absolute inset-0 bg-gradient-to-t from-cyan/20 to-transparent pointer-events-none" />
            </div>
            
            {/* Floating stats card */}
            <div className="absolute -bottom-6 left-2 z-20 bg-white/95 rounded-2xl p-6 shadow-xl animate-float">
              <p className="text-sm text-muted-foreground mb-1">Launch</p>
              <p className="text-4xl font-heading font-black text-primary">2026</p>
              <p className="text-sm text-muted-foreground">Jouw nieuwe manier van werkzoeken</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
